import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ChangePassword } from "../../../api/user/User";
import { toast } from "react-toastify";
import { LogoutAPI } from "../../../api/auth/Authentication";
type Inputs = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};
function SetPasswordForm() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>();
  const [isOpenEyeOldPassword, setIsOpenEyeOldPassword] = useState(false);
  const [isOpenEyeNewPassword, setIsOpenEyeNewPassword] = useState(false);
  const [isOpenEyeConfirmPassword, setIsOpenEyeConfirmPassword] =
    useState(false);
  const newPassword = watch("newPassword", "");
  const oldPassword = watch("oldPassword", "");
  const [isDisable, setIsDisable] = useState(false);
  const navigate = useNavigate();

  const handleClickOpenOldPassword = () => {
    setIsOpenEyeOldPassword(!isOpenEyeOldPassword);
  };
  const handleClickOpenNewPassword = () => {
    setIsOpenEyeNewPassword(!isOpenEyeNewPassword);
  };
  const handleClickOpenConfirmPassword = () => {
    setIsOpenEyeConfirmPassword(!isOpenEyeConfirmPassword);
  };
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    let payload = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    };
    try {
      await ChangePassword(payload);
      toast.success("เปลี่ยนรหัสผ่าน สำเร็จ", {
        position: "bottom-left",
        autoClose: 3000,
      });
      await LogoutAPI();
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("expired_at");
      localStorage.removeItem("refresh_token");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="inline-flex flex-col gap-6 w-full"
    >
      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-2 md:col-span-1 flex flex-col gap-1 w-full">
          <label className="text-sm text-text-primary" htmlFor="oldPassword">
            รหัสผ่านเดิม
          </label>
          <div
            className={`w-full h-10 rounded-2xl  border-[1px] border-gray-2 bg-primary-contrast px-4 flex gap-2`}
          >
            <input
              id="oldPassword"
              type={isOpenEyeOldPassword ? "text" : "password"}
              onInput={() => setIsDisable(true)}
              className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled self-stretch"
              {...register("oldPassword", { required: "กรุณากรอกรหัสผ่าน" })}
              onKeyPress={(event) => {
                if (!/^\S.*[a-zA-Z\s]*$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            <div
              className="items-center self-center w-8 cursor-pointer"
              onClick={handleClickOpenOldPassword}
            >
              {isOpenEyeOldPassword ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                    fill="#8E8E8E"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                    fill="#B0B0B0"
                  />
                </svg>
              )}
            </div>
          </div>
          {errors.oldPassword && (
            <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
              {errors.oldPassword.message}
            </span>
          )}
        </div>
        <div className="col-span-2 md:col-span-1 flex flex-col gap-1 w-full">
          <label className="text-sm text-text-primary" htmlFor="newPassword">
            รหัสผ่านใหม่
          </label>
          <div
            className={`w-full h-10 rounded-2xl border-[1px] border-gray-2 bg-primary-contrast px-4 flex gap-2`}
          >
            <input
              id="newPassword"
              type={isOpenEyeNewPassword ? "text" : "password"}
              onInput={() => setIsDisable(true)}
              className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled self-stretch"
              {...register("newPassword", {
                required: "กรุณากรอกรหัสผ่าน",
                validate: (value) =>
                  value !== oldPassword ||
                  "รหัสผ่านใหม่ไม่ควรตรงกันกับรหัสผ่านเดิม",
              })}
              onKeyPress={(event) => {
                if (!/^\S.*[a-zA-Z\s]*$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            <div
              className="items-center self-center w-8 cursor-pointer"
              onClick={handleClickOpenNewPassword}
            >
              {isOpenEyeNewPassword ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                    fill="#8E8E8E"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                    fill="#B0B0B0"
                  />
                </svg>
              )}
            </div>
          </div>
          {errors.newPassword && (
            <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
              {errors.newPassword.message}
            </span>
          )}
        </div>
        <div className="col-span-2 md:col-span-1 flex flex-col gap-1 w-full">
          <label
            className="text-sm text-text-primary"
            htmlFor="confirmPassword"
          >
            ยืนยันรหัสผ่าน
          </label>
          <div
            className={`w-full h-10 rounded-2xl border-[1px] border-gray-2 bg-primary-contrast px-4 flex gap-2`}
          >
            <input
              id="confirmPassword"
              type={isOpenEyeConfirmPassword ? "text" : "password"}
              onInput={() => setIsDisable(true)}
              className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled self-stretch"
              {...register("confirmPassword", {
                required: "กรุณากรอกรหัสผ่าน",
                validate: (value) =>
                  value === newPassword || "รหัสผ่านไม่ตรงกัน กรุณาลองอีกครั้ง",
              })}
              onKeyPress={(event) => {
                if (!/^\S.*[a-zA-Z\s]*$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            <div
              className="items-center self-center w-8 cursor-pointer"
              onClick={handleClickOpenConfirmPassword}
            >
              {isOpenEyeConfirmPassword ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                    fill="#8E8E8E"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                    fill="#B0B0B0"
                  />
                </svg>
              )}
            </div>
          </div>
          {errors.confirmPassword && (
            <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
              {errors.confirmPassword.message}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-2 self-start justify-between md:justify-end w-full md:self-end">
        <button className="px-10 py-2 w-full md:w-auto h-10 border-[1px] border-gray-2 text-text-primary text-base font-normal rounded-xl">
          ยกเลิก
        </button>
        <button
          disabled={!isDisable}
          className="px-10 py-2 h-10 w-full md:w-auto bg-primary-main disabled:bg-gray-1 disabled:text-text-disabled hover:bg-opacity-80 text-base text-primary-contrast  rounded-xl"
        >
          บันทึก
        </button>
      </div>
    </form>
  );
}

export default SetPasswordForm;
